import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconMoveAll = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg width={24} height={24} className={`${className} ${sizeOption}`} >
        <path
        d="m21.709 11.308-3-3.013a.999.999 0 0 0-1.414-.003.999.999 0 0 0-.004 1.414L18.58 11H13V5.409l1.291 1.297a.999.999 0 1 0 1.418-1.411l-2.987-3a.998.998 0 0 0-1.415-.003l-3.013 3a1 1 0 1 0 1.412 1.417L11 5.419V11H5.408l1.297-1.29a.999.999 0 1 0-1.41-1.417l-3 2.987a.997.997 0 0 0-.004 1.414l3 3.013a.997.997 0 0 0 1.414.003.999.999 0 0 0 .004-1.414L5.42 13H11v5.592l-1.291-1.297a1 1 0 1 0-1.418 1.41l2.987 3a1 1 0 0 0 .707.295h.002c.265 0 .519-.105.706-.291l3.013-3a1 1 0 1 0-1.412-1.417L13 18.58V13h5.592l-1.297 1.292a.999.999 0 1 0 1.41 1.417l3-2.987a.997.997 0 0 0 .004-1.414"
        fill="#1B1C22"
        fillRule="evenodd"
        />
    </svg>
  )
}